import script from "./additiveproduct.vue?vue&type=script&setup=true&lang=js"
export * from "./additiveproduct.vue?vue&type=script&setup=true&lang=js"

import "./additiveproduct.vue?vue&type=style&index=0&id=2a4892a2&lang=scss"
import "./additiveproduct.vue?vue&type=style&index=1&id=2a4892a2&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a4892a2"]])

export default __exports__